import { useEffect } from "react";
import styles from "./checkoutsuccess.module.css";
import { PiCheckBold } from "react-icons/pi";
import {
  SubHeadingTitle,
  Button,
  HeadingTitle,
} from "../../../../components/shared/index";
import { useLocation, Navigate, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";

const CheckoutSuccess = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { invoiceId, orderId } = location.state || {};
  useEffect(() => {
    window.scrollTo({ top: 550, behavior: "smooth" });
  }, []);

  if (!invoiceId) {
    toast.error("Order not found");
    return <Navigate to="" replace />;
  }

  return (
    <section className={styles.checkout_success__wrapper}>
      <div className={`${styles.wrapper} ${styles.fade_anim}`}>
        <div className={`${styles.iconWrapper} ${styles.tick_anim}`}>
          <PiCheckBold className={styles.icon} />
        </div>

        <HeadingTitle text="Order Placed Successfully 🎉" style={styles.title} />

        <SubHeadingTitle
          subTitle={`Thank you for shopping with us.
          Your Order ID: ${orderId}
          ${invoiceId ? `, Invoice ID: ${invoiceId}` : ""}`}
          style={styles.subTitle}
        />

        <div className={styles.actions}>
          <Button
            title="Track Order"
            style={styles.trackBtn}
            onHandler={() => navigate("/profile/order")}
          />

          <Button
            title="Continue Shopping"
            style={styles.continueBtn}
            onHandler={() => navigate("/shop")}
          />

          <Button
            title="Download Invoice"
            style={styles.invoiceBtn}
            onHandler={() => navigate(`/invoice/${invoiceId}`)}
          />
        </div>
      </div>
    </section>
  );
};

export default CheckoutSuccess;
